import React        from 'react';
import KnowMore     from '../../../global/globalToKnowMore';
import * as GV      from '../../../global/globalVariables';

function ToKnowMorePlanning() {
    
    return (
        <>
        <KnowMore appName={GV.APP_DIVORCE_PLANNING}></KnowMore>
        </>
    )
}

export default ToKnowMorePlanning;